<template>
  <div id="organization">
    <div class="title">
      <img src="../../assets/image/icon_zzjj@2x.png" alt />
      <h3>组织架构</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="organizationActive" @tab-click="handleClick">
        <!-- 成员管理 -->
        <el-tab-pane label="成员管理" name="1">
          <div class="searchRow">
            <el-input class="tableSearch" v-model="searchInfo1" placeholder="标题内容搜索"></el-input>
            <div class="btnCol">
              <el-button class="search" @click="handleSearch1">查询</el-button>
              <!-- <el-button class="creat" style="background-color:#40A0F2;" @click="addUserClick">新建</el-button> -->
            </div>
          </div>
          <el-table
            :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
            :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
            :data="tableData"
            stripe
            height="calc(100% - 68px - 20px - 50px)"
            style="width: 100%; margin-top:20px"
          >
            <el-table-column
              prop="nickname"
              :show-overflow-tooltip="true"
              align="center"
              label="姓名"
            ></el-table-column>
            <!-- <el-table-column
              prop="name"
              :show-overflow-tooltip="true"
              width="100"
              align="center"
              label="性别"
            ></el-table-column>-->
            <el-table-column
              prop="username"
              :show-overflow-tooltip="true"
              align="center"
              label="电话"
            ></el-table-column>
            <el-table-column
              prop="department_name"
              :show-overflow-tooltip="true"
              align="center"
              label="部门"
            ></el-table-column>
            <el-table-column prop="address" :show-overflow-tooltip="true" align="center" label="角色">
              <template slot-scope="scope">
                <span v-if="scope.row.admin_state=='1'">管理员</span>
                <span v-if="scope.row.is_department_head=='1'">部门主管</span>
                <span v-if="scope.row.is_evaluators=='1'">评价人员</span>
                <span
                  v-if="scope.row.is_evaluators!='1' && scope.row.is_department_head!='1' && scope.row.admin_state!='1'"
                >其他</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="add_time"
              :show-overflow-tooltip="true"
              align="center"
              width="200"
              label="加入时间"
            ></el-table-column>
            <el-table-column prop="address" :show-overflow-tooltip="true" align="center" label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.quit_status=='1'">离职</span>
                <span v-if="scope.row.quit_status!='1'">在职</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" width="300" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  :disabled="isAdmin1==0 ? false : true"
                  @click="handleEditUser(scope.row)"
                  class="tableBtn"
                >编辑</el-button>
                <el-button
                  :disabled="isAdmin1==0 ? false : true"
                  @click="handleRemoveUser(scope.row)"
                  class="tableBtn"
                  style="    border-color: #999999;color: #666666;"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pageRow" v-if="tableData.length>0">
            <el-pagination
              @size-change="handleUserSizeChange"
              @current-change="handleUserCurrentChange"
              :current-page="currentUserPage"
              background
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="userPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="userTotal"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 部门管理 -->
        <el-tab-pane label="部门管理" name="2">
          <div class="searchRow">
            <el-input class="tableSearch" v-model="searchInfo2" placeholder="标题内容搜索"></el-input>
            <div class="btnCol">
              <el-button class="search" @click="handleSearch2">查询</el-button>
              <el-button class="creat" style="background-color:#40A0F2;" @click="addClassClick">新建</el-button>
            </div>
          </div>
          <!-- <el-table
            :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
            :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
            :data="tableData2"
            stripe
            height="calc(100% - 68px - 20px - 50px)"
            style="width: 100%; margin-top:20px"
          >
            <el-table-column
              prop="department_name"
              width="300"
              :show-overflow-tooltip="true"
              align="center"
              label="部门名称"
            >
              <template slot-scope="scope">
                <p
                  style="width:100%; overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                  v-if="scope.row.department_name"
                >{{scope.row.department_name}}</p>
                <p v-else>---</p>
              </template>
            </el-table-column>
            <el-table-column prop="content" :show-overflow-tooltip="true" align="center" label="描述">
              <template slot-scope="scope">
                <p
                  style="width:100%; overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                  v-if="scope.row.content"
                >{{scope.row.content}}</p>
                <p v-else>-------</p>
              </template>
            </el-table-column>
            <el-table-column prop="address" width="400" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleEditClass(scope.row)"
                  :disabled="isAdmin2==0 ? false : true"
                  class="tableBtn"
                >编辑</el-button>
                <el-button
                  @click="handleRemoveClass(scope.row)"
                  class="tableBtn"
                  :disabled="isAdmin2==0 ? false : true"
                  style="border-color: #999999;color: #666666;"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>-->
          <tree-table
            :is-fold="false"
            :data="tableData2"
            children-prop="children"
            :columns="columns"
            :show-row-hover="false"
            :expand-type="false"
            :selection-type="false"
          >
            <template slot="name" slot-scope="scope">
              <!-- <span v-if="scope.row.name">{{scope.row.name +'123'}}</span> -->
            </template>
            <template slot="content" slot-scope="scope">
              <!-- v-if="scope.row.is_charge=='1' && scope.row.approve.length>0" -->
              <p
                style="width:100%; overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                v-if="scope.row.content"
              >{{scope.row.content}}</p>
              <p v-else>-------</p>
            </template>
            <template slot="edit" slot-scope="scope">
              <el-button
                @click="handleEditClass(scope.row)"
                :disabled="isAdmin2==0 ? false : true"
                class="tableBtn"
              >编辑</el-button>
              <el-button
                @click="handleRemoveClass(scope.row)"
                class="tableBtn"
                :disabled="isAdmin2==0 ? false : true"
                style="border-color: #999999;color: #666666;"
              >删除</el-button>
            </template>
          </tree-table>
          <!-- <div class="pageRow" v-if="tableData2.length>0">
            <el-pagination
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="currentPage2"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize2"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="total2"
            ></el-pagination>
          </div>-->
        </el-tab-pane>
        <!-- 系统公告 -->
        <el-tab-pane label="系统公告" name="3">
          <div class="searchRow">
            <el-input class="tableSearch" v-model="searchInfo3" placeholder="标题内容搜索"></el-input>
            <div class="btnCol">
              <el-button @click="handleSearchMessage" class="search">查询</el-button>
              <el-button class="creat" style="background-color:#40A0F2;" @click="addMessageClick">新建</el-button>
            </div>
          </div>
          <el-table
            :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
            :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
            :data="tableData3"
            stripe
            height="calc(100% - 68px - 20px - 50px)"
            style="width: 100%; margin-top:20px"
          >
            <el-table-column prop="title" :show-overflow-tooltip="true" align="center" label="标题"></el-table-column>
            <!-- <el-table-column
              prop="name"
              width="400"
              :show-overflow-tooltip="true"
              align="center"
              label="内容"
            ></el-table-column>-->
            <!-- edit -->
            <el-table-column
              prop="membername"
              :show-overflow-tooltip="true"
              align="center"
              label="发布人"
            ></el-table-column>
            <!-- edit -->
            <el-table-column
              prop="add_time"
              :show-overflow-tooltip="true"
              width="200"
              align="center"
              label="添加时间"
            ></el-table-column>
            <!-- <el-table-column prop="address" :show-overflow-tooltip="true" align="center" label="部门"></el-table-column> -->
            <!-- edit -->
            <el-table-column
              prop="update_time"
              :show-overflow-tooltip="true"
              width="200"
              align="center"
              label="更新时间"
            ></el-table-column>
            <!-- edit -->
            <el-table-column prop="address" width="300" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  :disabled="isAdmin3==0 ? false : true"
                  @click="handleEditMessage(scope.row)"
                  class="tableBtn"
                >编辑</el-button>
                <el-button
                  :disabled="isAdmin3==0 ? false : true"
                  @click="handleRemoveMessage(scope.row)"
                  class="tableBtn"
                  style="    border-color: #999999;color: #666666;"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pageRow" v-if="tableData3.length>0">
            <el-pagination
              @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3"
              :current-page="currentPage3"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize3"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="total3"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="dialogVisible"
      width="65%"
      style="margin-top:-5vh"
      :before-close="handleClose"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age" v-if="showForm=='1'">新增成员</span>
        <span class="title-age" v-if="showForm=='1-edit'">编辑成员</span>
        <span class="title-age" v-if="showForm=='2'">新增部门</span>
        <span class="title-age" v-if="showForm=='2-edit'">编辑部门</span>
        <span class="title-age" v-if="showForm=='3'">添加系统公告</span>
        <span class="title-age" v-if="showForm=='3-edit'">编辑系统公告</span>
      </div>
      <div class="diaContainer">
        <!-- 编辑成员管理表单 -->
        <el-form ref="form" :model="editUserForm" label-width="30%" v-if="showForm=='1-edit'">
          <el-form-item label="姓名">
            <!-- <el-input placeholder="请输入成员姓名" v-model="editUserForm.nickname"></el-input> -->
            <span style="font-size:14px">{{editUserForm.nickname}}</span>
          </el-form-item>
          <el-form-item label="部门">
            <!-- <el-select
              filterable
              :popper-append-to-body="false"
              popper-class="classChargePeople"
              class="heder40"
              v-model=".department_id"
              placeholder="请选部门"
            >
              <el-option
                v-for="item in tableData2"
                :key="item.department_id"
                :label="item.department_name"
                :value="item.department_id"
              ></el-option>
            </el-select>-->

            <el-cascader
              :modal-append-to-body="false"
              class="modifyCascader"
              v-model="editUserForm.pidArr"
              filterable
              clearable
              @change="handleUseEditChange"
              :options="selectClassList"
              :props="{ value:'department_id', label:'department_name',checkStrictly: true}"
              placeholder="请选部门"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="成员排序">
            <el-input placeholder="请输入排序序号" type="number" v-model="editUserForm.sort"></el-input>
          </el-form-item>
          <el-form-item label="在职状态">
            <el-radio-group v-model="editUserForm.quit_status">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否管理员">
            <el-radio-group v-model="editUserForm.admin_state">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否财务">
            <el-radio-group v-model="editUserForm.is_finance">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否评价人员">
            <el-radio-group v-model="editUserForm.is_evaluators">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否冻结">
            <el-radio-group v-model="editUserForm.state">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <!-- 新增部门表单 -->
        <el-form ref="form" :model="addClassForm" label-width="30%" v-if="showForm=='2'">
          <el-form-item label="部门名称">
            <el-input placeholder="请输入部门名称" v-model="addClassForm.department_name"></el-input>
          </el-form-item>
          <el-form-item label="父级部门">
            <el-cascader
              :modal-append-to-body="false"
              @change="handleCasAddChange"
              class="modifyCascader"
              filterable
              clearable
              v-model="addClassForm.pidArr"
              :options="selectClassList"
              :props="{ value:'department_id', label:'department_name', checkStrictly: true}"
              placeholder="请选父级部门"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="是否是项目负责部门">
            <el-radio-group v-model="addClassForm.is_business">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="部门/小组">
            <el-radio-group v-model="addClassForm.is_group">
              <el-radio label="0">部门</el-radio>
              <el-radio label="1">小组</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="背景颜色">
            <el-color-picker color-format="rgb" v-model="addClassForm.bg_color"></el-color-picker>
          </el-form-item>
          <el-form-item label="部门排序">
            <el-input placeholder="请输入排序序号" type="number" v-model="addClassForm.sort"></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input type="textarea" placeholder="请输入您的部门描述" v-model="addClassForm.content"></el-input>
          </el-form-item>
        </el-form>
        <!-- 编辑部门表单 -->
        <el-form ref="form" label-width="30%" v-if="showForm=='2-edit'">
          <el-form-item label="部门名称">
            <el-input placeholder="请输入部门名称" v-model="editClassForm.department_name"></el-input>
          </el-form-item>
          <el-form-item label="部门主管">
            <el-select
              filterable
              :popper-append-to-body="false"
              popper-class="classChargePeople"
              multiple
              v-model="editClassForm.chargePeople"
              @change="handleChangeSelectV"
              placeholder="请选部门主管"
            >
              <el-option
                v-for="item in userListSelect"
                :key="item.member_id"
                :label="item.nickname"
                :value="item.member_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="父级部门">
            <el-cascader
              :modal-append-to-body="false"
              class="modifyCascader"
              v-model="editClassForm.pidArr"
              clearable
              filterable
              @change="handleCasEditChange"
              :options="selectClassList"
              :props="{ value:'department_id', label:'department_name', checkStrictly: true}"
              placeholder="请选父级部门"
            ></el-cascader>
            <!-- <el-select
              filterable
              :popper-append-to-body="false"
              popper-class="classChargePeople"
              v-model=""
              placeholder="请选父级部门"
            >
              <el-option
                v-for="item in selectClassList"
                :key="item.department_id"
                :label="item.department_name"
                :value="item.department_id"
              ></el-option>
            </el-select>-->
          </el-form-item>
          <el-form-item label="是否是项目负责部门">
            <el-radio-group v-model="editClassForm.is_business">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="部门/小组">
            <el-radio-group v-model="editClassForm.is_group">
              <el-radio label="0">部门</el-radio>
              <el-radio label="1">小组</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="背景颜色">
            <el-color-picker color-format="rgb" v-model="editClassForm.bg_color"></el-color-picker>
          </el-form-item>
          <el-form-item label="部门排序">
            <el-input placeholder="请输入排序序号" type="number" v-model="editClassForm.sort"></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input type="textarea" placeholder="请输入您的部门描述" v-model="editClassForm.content"></el-input>
          </el-form-item>
        </el-form>
        <!-- 新增系统公告表单 -->
        <el-form
          ref="form"
          :model="addMessageForm"
          label-width="20%"
          v-if="showForm=='3'"
          class="yauto2"
        >
          <el-form-item label="标题">
            <el-input placeholder="请输入标题" v-model="addMessageForm.title"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <!-- 富文本 -->
            <div class="editUpdataBox" style="width:100%">
              <!-- <quill-editor
                ref="editQuillEditor"
                class="ql-editor"
                style="padding:0;margin-bottom:30px;width:80%;height:auto;"
                id="editdetailsquill"
                v-model="addMessageForm.content"
                :options="editorOptionedit"
              ></quill-editor>-->
              <VueUeditorWrap
                style="width:80%"
                v-model="addMessageForm.content"
                :config="myconfig"
              />
              <el-upload
                class="avatar-uploader avatar-uploader-display"
                style="display:none;"
                action="#"
                ref="addUpLoad"
                :show-file-list="false"
                :before-upload="beforeAvatarUploadEdit"
              >
                <img v-if="editMessageForm.content" :src="editMessageForm.content" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <!-- <div v-else class="ql-container ql-snow" style="margin:20px 0">
              <div class="ql-editor" v-html="addFormData.existing_problems"></div>
            </div>-->
            <!-- 富文本 -->
            <!-- <el-input type="textarea" placeholder="请输入内容" v-model="addMessageForm.content"></el-input> -->
          </el-form-item>
        </el-form>
        <!-- 编辑系统公告表单 -->
        <el-form
          ref="form"
          :model="editMessageForm"
          label-width="30%"
          v-if="showForm=='3-edit'"
          class="yauto2"
        >
          <el-form-item label="标题">
            <el-input placeholder="请输入标题" v-model="editMessageForm.title"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <!-- 富文本 -->
            <div class="editUpdataBox" style="width:100%">
              <!-- <quill-editor
                ref="editQuillEditor"
                class="ql-editor"
                style="padding:0;margin-bottom:30px;width:80%;height:auto;"
                id="editdetailsquill"
                v-model="editMessageForm.content"
                :options="editorOptionedit"
              ></quill-editor>-->
              <VueUeditorWrap
                style="width:80%"
                v-model="editMessageForm.content"
                :config="myconfig"
              />
              <el-upload
                class="avatar-uploader avatar-uploader-display"
                style="display:none;"
                action="#"
                ref="addUpLoad"
                :show-file-list="false"
                :before-upload="beforeAvatarUploadEdit"
              >
                <img v-if="editMessageForm.content" :src="editMessageForm.content" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <!-- <div v-else class="ql-container ql-snow" style="margin:20px 0">
              <div class="ql-editor" v-html="addFormData.existing_problems"></div>
            </div>-->
            <!-- 富文本 -->
            <!-- <el-input type="textarea" placeholder="请输入内容" v-model="editMessageForm.content"></el-input> -->
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="addFlag" @click="DiaClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VueUeditorWrap from 'vue-ueditor-wrap'

// 引入富文本相关 start
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as Quill from 'quill'
//quill编辑器的字体
var fonts = [
  'SimSun',
  'SimHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif',
]
var Font = Quill.import('formats/font')
Font.whitelist = fonts //将字体加入到白名单
Quill.register(Font, true)
//图片缩放
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize)
// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction

  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image', 'video'],
  ['clean'], // remove formatting button
]
const toolbarOptions1 = [
  [], // toggled buttons
  [],

  [], // custom button values
  [],
  [], // superscript/subscript
  [], // outdent/indent
  [], // text direction

  [], // custom dropdown
  [],

  [], // dropdown with defaults from theme
  [],
  [],
  [],
  [], // remove formatting button
]
// 引入富文本相关 end
export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      addFlag: false,
      showForm: '',
      organizationActive: '1',
      searchInfo1: '',
      searchInfo2: '',
      searchInfo3: '',
      currentUserPage: 1,
      userPageSize: 10,

      currentPage1: 1,
      pageSize1: 10,
      total1: 0,
      currentPage2: 1,
      pageSize2: 10,
      total2: 0,
      currentPage3: 1,
      pageSize3: 10,
      total3: 0,

      editClassName: '',
      editClassId: '',

      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      userTotal: 0,
      dialogVisible: false,
      myconfig: {
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: '//ueditor.szcloudplus.com/cos',
        // serverUrl: 'http://35.201.165.105:8000/controller.php',
        serverUrl: this.basURLStr + '/Public/UEditor/php/controller.php',
        // serverUrl: '/UEditor/php/controller.php',
        // 'https://test.control.sxpz.vip/Public/UEditor/php/controller.php',
        // serverUrl: '/UEditor/php/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/',
        // UEDITOR_HOME_URL: this.basURLStr + '/Public/UEditor/',
      },
      // 新增成员
      addUserForm: {
        name: '',
        chargePeople: '',
        status: '1',
        isCharge: '1',
        isAn: '1',
        isFreeze: '1',
        pidArr: '',
      },
      editUserForm: {},
      editUserId: '',
      // 新增部门表单
      addClassForm: {
        department_name: '',
        content: '',
        is_business: '0',
        is_group: '0',
        bg_color: '',
        pidArr: [],
        sort: '',
        pid: '',
      },
      editMessageId: '',
      // 新增消息表单
      addMessageForm: {
        title: '',
        content: '',
      },
      editMessageForm: { title: '', content: '' },
      editClassForm: {
        department_name: '',
        content: '',
        chargePeople: [],
        pidArr: [],
        is_business: '0',
        is_group: '0',
        bg_color: '',
        sort: '',
        pid: '',
      },
      tableData: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      selectClassList: [],
      isAdmin1: '',
      isAdmin2: '',
      isAdmin3: '',
      userListSelect: [],
      columns: [
        {
          label: '部门名称',
          type: 'template',
          template: 'department_name',
          prop: 'department_name',
          width: '300',
        },
        {
          label: '描述',
          type: 'template',
          template: 'content',
          width: '425',
        },

        {
          label: '操作',
          type: 'template',
          width: '150',
          template: 'edit',
        },
      ],
      // 富文本
      editorOptionedit1: {
        modules: {
          toolbar: {
            container: toolbarOptions1, // 工具栏
          },
        },
      },
      editorOptionedit: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // alert('自定义图片')
                  // 调用element图片上传
                  document
                    .querySelector('.editUpdataBox .avatar-uploader-icon')
                    .click()
                } else {
                  this.quill.format('image', false)
                }
              },
            },
          },
          imageResize: {}, // 配置图片可缩放大小
        },
      },
      // 富文本
    }
  },
  methods: {
    // 富文本上传
    async beforeAvatarUploadEdit(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      let param = new FormData()
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('member_id', this.member_id)
      param.append('file', file)
      // return console.log('param', param.get('access_token'))
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        // data: param,
        data: param,
      })
      // return console.log('res', res)
      if (res.code != 200) return this.$message.error(res.datas.msg)

      let quill = this.$refs.editQuillEditor.quill
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        let length = quill.getSelection().index
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, 'image', res.datas.img_url)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        // 提示信息，需引入Message
        this.$message.error('图片插入失败')
      }
      console.log('asdasdasdas')
      return new Promise((resolve, reject) => {
        this.$refs['addUpLoad'].validate((valid) => {
          if (valid) {
            return resolve(true)
          } else {
            return reject(false)
          }
        })
      })
    },
    handleSearch1() {
      this.currentUserPage = 1
      this.getUserList()
    },
    handleSearch2() {
      this.currentPage2 = 1
      this.getClassList()
    },
    handleSearchMessage() {
      this.currentUserPage = 1
      this.getMessageList()
    },
    DiaClick() {
      if (this.showForm === '2') {
        // 新增部门
        this.addClassFormSubmit()
      } else if (this.showForm === '2-edit') {
        // 编辑部门
        this.editClassFormSubmit()
      } else if (this.showForm === '1-edit') {
        // 编辑成员
        this.editUserFormSubmit()
      } else if (this.showForm === '3') {
        // 新增系统公告
        this.addMessageSubmit()
      } else if (this.showForm === '3-edit') {
        // 编辑系统公告
        this.editMessageSubmit()
      }
    },
    // *删除系统公告
    async handleRemoveMessage(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('notice_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/notice_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getMessageList()
      }
    },
    // *编辑系统公告
    async editMessageSubmit() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('notice_id', this.editMessageId)
        param.append('title', this.editMessageForm.title)
        param.append('content', this.editMessageForm.content)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/notice_edit',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getMessageList()
      }, this.timeDou)
    },
    // *新增系统公告
    async addMessageSubmit() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('title', this.addMessageForm.title)
        param.append('content', this.addMessageForm.content)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/notice_add',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getMessageList()
      }, this.timeDou)
    },
    // *获取公告列表
    async getMessageList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('search', this.searchInfo3)
      param.append('p', this.currentPage3)
      param.append('p_count', this.pageSize3)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/notice',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData3 = res.datas.listInfo
      this.total3 = parseInt(res.datas.count)
      this.isAdmin3 = res.datas.admin_state
      console.log('系统公告列表', this.tableData3)
    },

    // *编辑成员提交
    async editUserFormSubmit() {
      if (!this.editUserForm.department_id) {
        return this.$message.error('请选择部门')
      }
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)
        param.append('to_member_id', this.editUserId)

        param.append('sort', this.editUserForm.sort)
        param.append('department_id', this.editUserForm.department_id)
        param.append('admin_state', this.editUserForm.admin_state)
        param.append('is_finance', this.editUserForm.is_finance)
        param.append('is_evaluators', this.editUserForm.is_evaluators)
        param.append('state', this.editUserForm.state)
        param.append('quit_status', this.editUserForm.quit_status)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/member_edit',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getUserList()
      }, this.timeDou)
    },
    // *获取成员
    async getUserList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('search', this.searchInfo1)
      param.append('department_id', '')
      param.append('p', this.currentUserPage)

      param.append('p_count', this.userPageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/member',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData = res.datas.listInfo
      this.userTotal = parseInt(res.datas.count)
      this.isAdmin1 = res.datas.admin_state
      console.log('成员列表', this.tableData)
    },

    // *删除部门
    async handleRemoveClass(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)
        param.append('department_id', row.department_id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/department_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getClassList()
      }
    },
    // *点击编辑部门
    async handleEditClass(row) {
      // return console.log('row', row)
      this.showForm = '2-edit'
      this.getUserListSelect(row.department_id)
      this.editClassForm.content = row.content
      this.editClassForm.department_name = row.department_name
      // this.editClassForm.chargePeople = row.department_head
      if (row.department_head) {
        this.editClassForm.chargePeople = row.department_head.map((item) => {
          if (item.member_id) {
            return item.member_id
          } else {
            return item
          }
        })
      }
      // console.log(
      //   'this.editClassForm.chargePeople',
      //   this.editClassForm.chargePeople
      // )
      this.editClassForm.is_business = row.is_business
      this.editClassForm.is_group = row.is_group
      this.editClassForm.pid = row.pid
      this.editClassForm.pidArr = [row.pid]
      this.editClassForm.sort = row.sort
      this.editClassForm.bg_color = row.bg_color
      this.editClassId = row.department_id
      this.dialogVisible = true
      // console.log('this.userListSelect', this.userListSelect)
      console.log('this.editClassForm', this.editClassForm)
    },
    handleChangeSelectV() {
      console.log(
        'this.editClassForm.chargePeople',
        this.editClassForm.chargePeople
      )
    },
    // 获取当前部门下的成员
    async getUserListSelect(id) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('department_id', id)
      param.append('p_count', 10000)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/member',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.userListSelect = res.datas.listInfo
    },
    // *编辑部门提交
    async editClassFormSubmit() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('department_id', this.editClassId)

        param.append('department_name', this.editClassForm.department_name)
        param.append('pid', this.editClassForm.pid)
        param.append('sort', this.editClassForm.sort)
        param.append('content', this.editClassForm.content)
        param.append('is_group', this.editClassForm.is_group)
        param.append(
          'department_head',
          this.editClassForm.chargePeople.join(',')
        )
        param.append('bg_color', this.editClassForm.bg_color)
        param.append('is_business', this.editClassForm.is_business)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/department_edit',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getClassList()
      }, this.timeDou)
    },
    // *新增部门提交
    async addClassFormSubmit() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('department_name', this.addClassForm.department_name)
        param.append('pid', this.addClassForm.pid)
        param.append('sort', this.addClassForm.sort)
        param.append('content', this.addClassForm.content)
        param.append('is_business', this.addClassForm.is_business)
        param.append('is_group', this.addClassForm.is_group)
        param.append('bg_color', this.addClassForm.bg_color)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/department_add',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getClassList()
      }, this.timeDou)
    },
    handleCasAddChange(val) {
      if (val.length > 0) {
        this.addClassForm.pid = val[val.length - 1]
      }
      console.log(this.addClassForm.pid)
    },
    handleCasEditChange(val) {
      console.log(val)

      if (val.length > 0) {
        this.editClassForm.pid = val[val.length - 1]
      }
      // console.log(this.editClassForm.pid)
    },
    handleUseEditChange(val) {
      if (val && val.length > 0) {
        this.editUserForm.department_id = val[val.length - 1]
        console.log(
          'this.editUserForm.department_id = val[val.length - 1]',
          (this.editUserForm.department_id = val[val.length - 1])
        )
      }
    },
    // *获取部门列表
    async getClassList() {
      this.selectClassList = []
      this.tableData2 = []
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('search', this.searchInfo2)
      // param.append('p', this.currentPage2)
      // param.append('p_count', this.pageSize2)
      param.append('p', 1)
      param.append('p_count', 1000)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/department',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData2 = [...res.datas.listInfo]
      this.selectClassList = [...res.datas.listInfo]
      this.selectClassList.unshift({
        department_id: '0',
        department_name: '公司',
      })
      this.total2 = parseInt(res.datas.count)
      this.tableData2.forEach((item) => {
        this.handleMemberId(item)
      })
      this.isAdmin2 = res.datas.admin_state
      console.log('部门列表', this.tableData2)
    },
    // (递归处理)
    handleMemberId(item) {
      if (!item.children) {
        let c = []
        if (item.department_head && item.department_head.length > 0) {
          item.department_head.forEach((items) => {
            c.push(items.member_id)
          })
        }
        return (item.department_head = c)
      } else {
        item.children.forEach((items) => this.handleMemberId(items))
      }
    },
    // 点击新增成员
    addUserClick() {
      this.showForm = '1'
      this.dialogVisible = true
    },
    // *点击编辑成员
    async handleEditUser(row) {
      this.showForm = '1-edit'
      this.editUserId = row.member_id
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('to_member_id', row.member_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/member_info',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.editUserForm = res.datas.info
      if (this.editUserForm.department_id == '0') {
        this.editUserForm.department_id = ''
      }
      console.log('编辑成员详情', this.editUserForm)
      this.editUserForm.pidArr = this.editUserForm.department_id
      this.dialogVisible = true
    },
    // 点击新增部门
    addClassClick() {
      this.showForm = '2'
      this.dialogVisible = true
    },

    // 点击新增系统公告
    addMessageClick() {
      this.showForm = '3'
      this.dialogVisible = true
    },
    // 点击编辑系统公告
    handleEditMessage(row) {
      this.showForm = '3-edit'
      this.editMessageForm.title = row.title
      this.editMessageForm.content = row.content
      this.editMessageId = row.id
      this.dialogVisible = true
    },
    // 删除成员
    async handleRemoveUser(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('to_member_id', row.member_id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/member_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getUserList()
      }
    },
    handleClick(tab, event) {
      console.log(tab, event)
      if (tab.index == '0') {
        this.getUserList()
      } else if (tab.index == '1') {
        this.getClassList()
      } else if (tab.index == '2') {
        this.getMessageList()
      }
    },
    getId() {
      this.organizationActive = this.$route.query.type
    },
    handleUserSizeChange(val) {
      this.userPageSize = val
      this.getUserList()
    },
    handleUserCurrentChange(val) {
      this.currentUserPage = val
      this.getUserList()
    },
    handleSizeChange1(val) {
      this.pageSize1 = val
      this.currentPage1 = 1
      this.getUserList()
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val
      this.getUserList()
    },
    handleSizeChange2(val) {
      this.pageSize2 = val
      this.currentPage2 = 1
      this.getClassList()
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val
      this.getClassList()
    },
    handleSizeChange3(val) {
      this.pageSize3 = val
      this.currentPage3 = 1
      this.getMessageList()
    },
    handleCurrentChange3(val) {
      this.currentPage3 = val
      this.getMessageList()
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.addUserForm = {
        name: '',
        chargePeople: '',
        status: '1',
        isCharge: '1',
        isAn: '1',
        isFreeze: '1',
      }
      this.editUserForm = {}
      this.addClassForm = {
        department_name: '',
        content: '',
        is_business: '0',
        is_group: '0',
        bg_color: '',
        pidArr: [],
        sort: '',
        pid: '0',
      }

      this.addMessageForm = {
        name: '',
        remark: '',
      }

      this.editMessageForm = { title: '', content: '' }

      this.userListSelect = []

      this.editClassForm.department_name = ''
      this.editClassForm.content = ''
      this.editClassForm.chargePeople = []
      this.editClassForm.pidArr = []
      this.editClassForm.is_business = '0'
      this.editClassForm.is_group = '0'
      this.editClassForm.bg_color = ''
      this.editClassForm.sort = ''
      this.editClassForm.pid = '0'

      // this.editClassForm = {
      //   department_name: '',
      //   content: '',
      //   chargePeople: [],
      //   pidArr: [],
      //   is_business: '0',
      //   bg_color: '',
      //   sort: '',
      //   pid: '0',
      // }

      this.editMessageId = ''
      this.editClassId = ''
      this.editUserId = ''
      this.addFlag = false
    },
  },
  watch: {
    $route: 'getId',
  },
  components: {
    VueUeditorWrap,
  },
  created() {
    console.log('this.$route.query.type', this.$route.query.type)
    this.organizationActive = this.$route.query.type
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    if (!this.company_id) {
      this.$message.error('请重新选择您要进入的企业')
      this.$router.push('/join')
    }
    this.getUserList()
    this.getClassList()
    this.getMessageList()
  },
}
</script>
<style lang="less" scoped>
#organization {
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;
  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }
  // 表格主体
  .tableContainer {
    width: 100%;
    border-radius: 10px;
    height: calc(100% - 90px - 30px);
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 40px;
    padding-top: 20px;
    // 搜索行
    .searchRow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      /deep/.tableSearch {
        width: 28%;
        // (deep)
        .el-input__inner {
          padding-left: 25px;
          height: 45px;
          border-radius: 24px;
          font-size: 16px;
          border: none;
          background-color: #f4f5f6;
          color: #333;
          &::placeholder {
            color: #333;
          }

          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #333;
          }

          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #333;
          }
        }
      }
      .btnCol {
        display: flex;
        align-items: center;
        /deep/.el-button {
          font-size: 18px;
          font-weight: normal;
          border: none;
          width: 130px;
          height: 45px;
          background: #f4a029;
          color: #fff;
          border-radius: 24px;
          padding: 0;
          margin-left: 30px;
        }
      }
    }
    /deep/.el-table__header {
      box-sizing: border-box;
      th {
        border-color: #40a0f2 !important;
      }
      .gutter {
        background-color: #40a0f2;
      }
    }
    // 分页行
    .pageRow {
      box-sizing: border-box;
      padding-top: 10px;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
    // 表格行
    /deep/.el-table__body {
      width: 100% !important;
    }
    .el-table::before {
      display: none;
    }
    /deep/.el-table__body-wrapper {
      box-sizing: border-box;
      border: 1px solid #f4f5f6;
    }
    // 鼠标经过效果
    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #eff8ff;
    }
    // 斑马颜色
    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #f4f5f6;
    }
    // 滚动条的宽度
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      // position: absolute;
      // bottom: 0;
      width: 6px; // 横向滚动条
      height: 5px; // 纵向滚动条 必写
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background-color: #ccc;
    }
    // *修改tabs样式
    /deep/.el-tabs__active-bar {
      width: 60px !important;
      margin-left: 30px;
    }
    /deep/.el-tabs {
      width: 100%;
      height: 100%;
      .el-tabs__header {
        width: 100%;
        margin-bottom: 20px;
        .el-tabs__nav-wrap {
          width: 100%;
          .el-tabs__nav-scroll {
            width: 100%;
            .el-tabs__nav {
              box-sizing: border-box;
              padding-left: 20px;
              width: 100%;
            }
          }
        }
      }
      .el-tabs__content {
        height: calc(100% - 80px);
        .el-tab-pane {
          height: 100%;
        }
      }
    }
    /deep/.el-tabs__item {
      height: 60px;
      text-align: center;
      font-size: 20px;
      color: #999999;
      font-weight: 400;
      padding-right: 180px;
      // width: 17%;
    }
    /deep/.el-tabs__item.is-active {
      color: #333 !important;
    }
    /deep/.el-tabs__item:hover {
      color: #333 !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      color: #999999;
    }
    // 修改tabs样式
  }
  // 表格操作按钮
  .tableBtn {
    padding: 0;
    // display: flex;
    justify-content: center;
    width: 80px;
    height: 32px;
    border-color: #40a0f2;
    color: #0099ff;
    border-radius: 5px;
    font-weight: normal;
  }
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 50px;
      padding: 0;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 40px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }

  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    padding-right: 50px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    display: flex;
    // (deep)
    .el-select {
      width: 100%;
      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        // font-size: 18px;
        font-size: inherit;
      }
    }
    .el-input__inner {
      // font-size: 18px;
      font-size: inherit;
      width: 80%;
      height: 40px;
      border-radius: 0;
    }
    .el-cascader {
      width: 80%;
      .el-input {
        width: 100%;
      }
      .el-input__inner {
        width: 100%;
        font-size: inherit;
      }
    }
    .el-textarea {
      width: 80%;
      .el-textarea__inner {
        height: 250px;
        // font-size: 18px;
        font-family: Microsoft YaHei;
        font-size: inherit;
        resize: none;
        border-radius: 0;
      }
    }
    .el-radio-group {
      height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      .el-radio {
        display: flex;
        align-items: center;
        margin-right: 15%;
      }
      .el-radio__input {
        width: 18px;
        height: 18px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        // font-size: 18px;
        font-size: inherit;
      }
    }
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
  /deep/.heder40 {
    height: 56px;
  }
}
/deep/.ql-container {
  font-size: inherit;
}
.yauto {
  height: 40vh;
  overflow-y: auto;
}
.yauto2 {
  height: 60vh;
  overflow-y: auto;
}
.yauto::-webkit-scrollbar {
  width: 5px !important;
}
.yauto::-webkit-scrollbar-track {
  -webkit-box-shadow: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.yauto::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: rgba(0, 0, 0, 0.5);
}

.ql-container {
  width: 95%;
  height: initial;
}
/deep/.v-modal {
  z-index: 400 !important;
}
/deep/.el-dialog__wrapper {
  z-index: 500 !important;
}
// 修改表格样式
/deep/.zk-table {
  margin-top: 20px;
  font-size: 16px;
}
/deep/.zk-table__body-row {
  height: 60px;
}
/deep/.zk-table__body-row:not(:first-of-type) {
  // border-top: none;
}
/deep/.zk-table__header-row {
  background-color: #40a0f2;
  line-height: 50px;
  font-size: 20px;
  color: #fff;
  .zk-table__header-cell {
    font-weight: normal;
  }
}
/deep/.zk-table--firstProp-header-inner {
  padding-left: 15px;
}
/deep/.zk-table {
  height: calc(100% - 85px);
  .zk-table__body-wrapper {
    height: calc(100% - 65px) !important;
    overflow-y: auto;
  }
}
</style>